/** A pivot code cell's parsed `<code>|<_id>` label. */
type PivotLinkLabel = { code: string; _id: string }

/**
 * Parses a pivot cell label built as `<code>|<_id>` (or `<_id>|<code>` when `reversed`) into its
 * code and entity id. A label with no `|` carries no id to link to, so this returns `undefined`
 * and the caller keeps rendering the plain label text.
 */
export const parsePivotLinkLabel = (label: string, reversed = false): PivotLinkLabel | undefined => {
  if (!label.includes('|')) return undefined
  const [first, second] = label.split('|')
  const [code, _id] = reversed ? [second, first] : [first, second]
  return { code, _id }
}
